var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-p",on:{"click":_vm.toTech}},[_vm._v(_vm._s(_vm.params.data.tech_name))])}
var staticRenderFns = []

export { render, staticRenderFns }